import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/app/profile/page.tsx");
